export default "__VITE_ASSET__BJx7nVRH__"